
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";
import { useI18n } from "../i18n";
import { navigationItems } from "../navigation";

const Footer = () => {
    const currentYear = new Date().getFullYear();
    const { t, services } = useI18n();

    return (
        <footer className="relative overflow-hidden bg-slate-50 text-slate-900">
            {/* Background decorations */}
            <div
                aria-hidden="true"
                className="pointer-events-none  absolute -right-40 -top-40 h-96 w-96 rounded-full bg-cyan-400/[0.08]"
            />

            <div
                aria-hidden="true"
                className="pointer-events-none absolute -bottom-48 -left-40 h-96 w-96 rounded-full bg-blue-400/[0.06]"
            />

            <div className="relative mx-auto max-w-7xl  px-5 sm:px-8 lg:px-10">
                {/* Main footer */}
                <div className="grid gap-12 py-14 sm:grid-cols-2  lg:grid-cols-4 lg:gap-10 lg:py-16">
                    {/* Brand */}
                    <div className="lg:col-span-1">
                        <Link
                            to="/"
                            aria-label={`${t("accessibility.logo")} — ${t("navigation.home")}`}
                            className="inline-flex items-center"
                        >
                            <img
                                src={logo}
                                alt={t("accessibility.logo")}
                                className="h-24 w-24 object-contain"
                            />
                        </Link>

                        <p className="mt-5 max-w-xs text-sm leading-7 text-slate-600">
                            {t("footer.description")}
                        </p>

                        {/* Social links
                        <div className="mt-6 flex items-center gap-3">
                            <a
                                href="https://www.linkedin.com/"
                                target="_blank"
                                rel="noreferrer"
                                aria-label="LinkedIn"
                                className="flex h-10 w-10 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 transition-colors hover:border-cyan-400 hover:bg-cyan-50 hover:text-cyan-600"
                            >
                                <svg
                                    viewBox="0 0 24 24"
                                    fill="currentColor"
                                    className="h-5 w-5"
                                    aria-hidden="true"
                                >
                                    <path d="M19 3A2 2 0 0 1 21 5V19A2 2 0 0 1 19 21H5A2 2 0 0 1 3 19V5A2 2 0 0 1 5 3H19ZM8.34 17.67V9.74H5.71V17.67H8.34ZM7.03 8.66A1.53 1.53 0 1 0 7.05 5.6A1.53 1.53 0 0 0 7.03 8.66ZM18.29 17.67V13.32C18.29 10.99 17.05 9.9 15.4 9.9C14.07 9.9 13.47 10.63 13.14 11.14V9.74H10.51C10.55 10.49 10.51 17.67 10.51 17.67H13.14V13.24C13.14 13 13.16 12.77 13.23 12.6C13.42 12.14 13.85 11.66 14.57 11.66C15.52 11.66 15.9 12.38 15.9 13.44V17.67H18.29Z" />
                                </svg>
                            </a>

                            <a
                                href="https://www.facebook.com/"
                                target="_blank"
                                rel="noreferrer"
                                aria-label="Facebook"
                                className="flex h-10 w-10 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 transition-colors hover:border-cyan-400 hover:bg-cyan-50 hover:text-cyan-600"
                            >
                                <svg
                                    viewBox="0 0 24 24"
                                    fill="currentColor"
                                    className="h-5 w-5"
                                    aria-hidden="true"
                                >
                                    <path d="M13.4 21V12.8h2.76l.41-3.2H13.4V7.56c0-.93.26-1.56 1.59-1.56h1.7V3.14A22.1 22.1 0 0 0 14.21 3C11.75 3 10.06 4.5 10.06 7.27V9.6H7.3v3.2h2.76V21h3.34Z" />
                                </svg>
                            </a>
                        </div> */}
                    </div>

                    {/* Navigation */}
                    <div>
                        <h3 className="text-base font-semibold text-slate-900">
                            {t("footer.quickLinks")}
                        </h3>

                        <div className="mt-5 h-0.5 w-10 rounded-full bg-cyan-500" />

                        <ul className="mt-5 space-y-4">
                            {navigationItems.map((item) => (
                                <li key={item.path}>
                                    <Link
                                        to={item.path}
                                        className="inline-flex items-center gap-2 text-sm text-slate-600 transition-colors hover:text-cyan-600"
                                    >
                                        <span
                                            aria-hidden="true"
                                            className="h-1 w-1 shrink-0 rounded-full bg-cyan-500"
                                        />
                                        {t(item.key)}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Services */}
                    <div>
                        <h3 className="text-base font-semibold text-slate-900">
                            {t("footer.ourServices")}
                        </h3>

                        <div className="mt-5 h-0.5 w-10 rounded-full bg-cyan-500" />

                        <ul className="mt-5 space-y-4">
                            {services.items.map((service) => (
                                <li key={service.id}>
                                    <Link
                                        to={`/${service.id}`}
                                        className="inline-flex items-center gap-2 text-sm text-slate-600 transition-colors hover:text-cyan-600"
                                    >
                                        <span
                                            aria-hidden="true"
                                            className="h-1 w-1 shrink-0 rounded-full bg-cyan-500"
                                        />
                                        {service.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Contact */}
                    <div>
                        <h3 className="text-base font-semibold text-slate-900">
                            {t("footer.getInTouch")}
                        </h3>

                        <div className="mt-5 h-0.5 w-10 rounded-full bg-cyan-500" />

                        <div className="mt-5 space-y-5">
                            {/* Location */}
                            <div className="flex items-start gap-3">
                                <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-cyan-100 bg-cyan-50 text-cyan-600">
                                    <svg
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="1.7"
                                        className="h-5 w-5"
                                        aria-hidden="true"
                                    >
                                        <path d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Z" />
                                        <circle cx="12" cy="10" r="2.5" />
                                    </svg>
                                </div>

                                <div>
                                    <p className="text-xs text-slate-500">
                                        {t("footer.location")}
                                    </p>

                                    <p className="mt-1 text-sm text-slate-700">
                                        {t("contact.address")}
                                    </p>
                                </div>
                            </div>

                            {/* Email */}
                            <div className="flex items-start gap-3">
                                <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-cyan-100 bg-cyan-50 text-cyan-600">
                                    <svg
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="1.7"
                                        className="h-5 w-5"
                                        aria-hidden="true"
                                    >
                                        <rect
                                            x="3"
                                            y="5"
                                            width="18"
                                            height="14"
                                            rx="2"
                                        />
                                        <path d="m4 7 8 6 8-6" />
                                    </svg>
                                </div>

                                <div className="min-w-0">
                                    <p className="text-xs text-slate-500">
                                        {t("footer.email")}
                                    </p>

                                    <a
                                        href="mailto:info@seaway.am"
                                        className="mt-1 block break-all text-sm text-slate-700 transition-colors hover:text-cyan-600"
                                    >
                                        info@seaway.am
                                    </a>
                                </div>
                            </div>

                            {/* Phone */}
                            <div className="flex items-start gap-3">
                                <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-cyan-100 bg-cyan-50 text-cyan-600">
                                    <svg
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="1.7"
                                        className="h-5 w-5"
                                        aria-hidden="true"
                                    >
                                        <path d="M6.6 3h3l1.5 4-2 1.5a15 15 0 0 0 6.4 6.4l1.5-2 4 1.5v3a2 2 0 0 1-2.2 2A17.8 17.8 0 0 1 4.6 5.2 2 2 0 0 1 6.6 3Z" />
                                    </svg>
                                </div>

                                <div>
                                    <p className="text-xs text-slate-500">
                                        {t("footer.phone")}
                                    </p>

                                    <a
                                        href="tel:+37493118112"
                                        className="mt-1 block text-sm text-slate-700 transition-colors hover:text-cyan-600"
                                    >
                                        +374 93-11-81-12
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bottom bar */}
                <div className="flex flex-col gap-3 border-t border-slate-200 py-6 text-start sm:flex-row sm:items-center sm:justify-between sm:text-left">
                    <p className="text-xs leading-6 text-slate-500">
                        © {currentYear} Seaway Logistics. {t("footer.rights")}
                    </p>

                    <p className="text-sm text-slate-600">
                        {t("footer.createdBy")}{" "}
                        <a
                            href="https://timetocode.vercel.app"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="font-semibold text-cyan-600 transition-colors hover:text-cyan-800"
                        >
                            Time To Code
                        </a>{" "}
                        {t("footer.createdBySuffix")}
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
